<script>
  import { onMount } from "svelte";
  import { loadHighlight, userState } from "../util/highlight-loader.js";
  import { ethers } from "ethers";
  import { fetchContributor } from "../util/data-fetcher.js";
  import SignInButton from "./SignInButton.svelte";

  let contrib;

  let loadingContrib = false;
  let raf;

  function updateContribution() {
    loadingContrib = true;
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(doFetch);
  }
  async function doFetch() {
    try {
      if (state && state.walletAddress) {
        contrib = await fetchContributor({
          address: state.walletAddress,
        });
      } else {
        contrib = null;
      }
    } finally {
      loadingContrib = false;
    }
  }

  let state;
  const unsubState = userState.subscribe((v) => {
    state = v;
    updateContribution();
  });
  onMount(() => {
    return () => {
      unsubState();
    };
  });
</script>

<div class="connect-container">
  {#await loadHighlight() then}
    <!-- <div class="connect-button">
      <div class="connect-button" data-widget="highlight-connect-wallet"></div>
    </div> -->
    <SignInButton />
    <div class="connect-info">
      {#if state && state.walletAddress}
        {#if loadingContrib}
          Loading...
        {:else if contrib && contrib.total_contribution}
          <div>
            Your total contribution is <strong
              >{ethers.formatEther(contrib.total_contribution)} ETH</strong
            >
            from <strong>{contrib.total_minted}</strong>
            mint{contrib.total_minted > 1 ? "s" : ""}.
          </div>
        {:else}
          No contributions found for address <strong
            >{state.walletAddress}</strong
          >
        {/if}
      {:else}
        Sign into your wallet to check your total contribution.
      {/if}
    </div>
  {/await}
</div>

<style>
  .connect-container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 20px;
  }
  .connect-info {
    /* flex-basis: 25%; */
    /* max-width: 280px; */
    font-size: 11px;
    flex-grow: 1;
    flex-shrink: 1;
    font-style: italic;
    padding: 0;
    margin: 0;
  }
</style>
